import React, { useContext, createContext, useState, useEffect } from 'react';
import { features } from 'configs';
import { PropTypes } from 'prop-types';
import consentRequests from 'services/consentRequests';
import { useUserContext } from 'store';

const initialState = {
  granted: [
    [
      {
        pat_name: 'Não Encontrado',
        pat_id: 'Não Encontrado',
        date: 'Não Encontrado',
        horario: 'Não Encontrado',
      },
    ],
    [
      {
        pat_name: 'Não Encontrado',
        pat_id: 'Não Encontrado',
        date: 'Não Encontrado',
        horario: 'Não Encontrado',
        institution: 'Não Encontrado',
      },
    ],
  ],
  received: [
    {
      pat_name: 'Não Encontrado',
      pat_id: 'Não Encontrado',
      date: 'Não Encontrado',
      horario: 'Não Encontrado',
    },
  ],
};

const TabAreaContext = createContext(initialState);

export function TabAreaContextProvider({ children }) {
  const [user] = useUserContext();
  const [granted, setGranted] = useState(initialState.granted);
  const [received, setReceived] = useState(initialState.received);
  const [refetch, setRefetch] = useState(false);
  const [loading, setLoading] = useState(false);

  function refetchTabArea() {
    setRefetch((prevState) => !prevState);
  }

  useEffect(() => {
    async function asyncCalls() {
      setLoading(true);
      if (features.granted) {
        await consentRequests.getConsentGranted(user.cpf).then((response) => {
          setGranted(response);
        });
      } else setGranted([]);

      await consentRequests.getConsentReceived(user.cpf).then((response) => {
        setReceived(response?.[0]);
      });
      setLoading(false);
    }
    asyncCalls();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetch]);

  return (
    <TabAreaContext.Provider
      value={{
        granted,
        received,
        refetchTabArea,
        loading,
      }}
    >
      {children}
    </TabAreaContext.Provider>
  );
}

export function useTabAreaContext() {
  return useContext(TabAreaContext);
}

TabAreaContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
};
